import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";

const QUERY = gql`
  query me {
    me {
      role
      firstName
      lastName
      email
    }
  }
`;

const useMe = () => {
  const { loading, error, data, refetch } = useQuery(QUERY, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
  });

  return { loading, error, refetch, data: data?.me };
};

export default useMe;
